import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _, { get } from 'lodash';
import { ucwords } from 'helper';
import * as actions from '../../../../actions';
import * as c from '../../../../constant';
// import CreateBusinessActivity from './CreateBusinessActivity';
import UpdateBusinessActivity from './UpdateBusinessActivity';

function ExistingBusinessActivityList({ value, onChange, previousActivity, getNecessaryFieldsList, necessaryFieldsList }) {
  const [viewUpdateForm, setViewUpdateForm] = useState(false);
  const [indexSelected, setIndex] = useState('');
  const [formData, setFormData] = useState({});

  const [items, setItem] = useState({
    item: [],
  });

  useEffect(() => {
    let result = value;
    result = result.map((n, i) => {
      return {
        ...n,
        id: i + 1,
      };
    });
    setItem({
      item: result || [],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value.length]);

  const updateProps = newItem => {
    onChange(_.get(newItem, 'item'));
  };

  const closeUpdateModal = () => {
    setViewUpdateForm(false);
    setIndex('');
  };

  const handleUpdateBusinessActivity = (data, index) => e => {
    e.preventDefault();
    setIndex(index);
    setViewUpdateForm(true, setFormData(data));
  };

  const handleOnUpdate = data => e => {
    e.preventDefault();
    if(_.get(data, 'value')){
      getNecessaryFieldsList({ business_line_id: _.get(data, 'value') })
    }
    
    const necessary_details = necessaryFieldsList.map((item) => {
      return item.multiplier
    })

    setIndex('');
    const details = _.omit(
      data,
      'business_nature_id',
      'business_line_id',
      'capital_amount',
      'gross_amount',
      'activity_id',
      'business_line_id',
      'business_nature_id',
      'capital_amount',
      'gross_amount',
      'id',
      'line_of_business',
      'initial_data',
      'business_nature_name',
      'business_line_name'
    );

    // ConfirmAlert(
    //   'Are you sure you want to update this business activity?',
    //   () => {

    const finalItem = items.item.map(x => {
      if (x.id === data.id) {
        return {
          ...x,
          business_nature_id: _.get(data, 'business_nature_id'),
          business_line_id: _.get(data, 'business_line_id'),
          business_nature_name: _.get(data, 'business_nature_name'),
          business_line_name: _.get(data, 'business_line_name'),
          line_of_business: _.get(data, 'line_of_business'),
          capital_amount: _.get(data, 'capital_amount'),
          gross_amount: _.get(data, 'gross_amount'),
          activity_id: _.get(x, 'activity_id'),
          details: _.pick(details, necessary_details),
        };
      }
      return x;
    });

    const newItem = {
      item: finalItem,
    };

    setItem(newItem);
    updateProps(newItem);
    setViewUpdateForm(false);

    // },
    // () => { },
    // {
    //   yesLabel: 'Confirm',
    //   noLabel: 'Cancel',
    // }
    // );
  };

  const finalPrev = previousActivity.filter(o1 =>
    items.item.some(o2 => +o1.id === +o2.activity_id)
  );

  return (
    <div className="p-2">
      <div className="mt-2 equal-box">
        <div className="equal-box-col mt-2">
          {(finalPrev || []).map((businessActivity, index) => {
            const details = get(businessActivity, 'attributes.details') || {};
            return (
              <div
                className={`col-12 p-3 rounded ${
                  index > 0 ? 'border-top' : ''
                }`}
                key={businessActivity.id}
              >
                <span className="text-primary font-weight-bold">
                  {' '}
                  Previous Information{' '}
                </span>
                <table className="transaction-table table table-borderless table-sm mt-4">
                  <tbody>
                    <tr>
                      <td className="text-dark" width="180">
                        Business Nature
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>
                          {get(
                            businessActivity,
                            'attributes.business_nature_name'
                          ) || '-'}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="180">
                        Business Line
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>
                          {get(
                            businessActivity,
                            'attributes.business_line_name'
                          ) || '-'}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="180">
                        Capital Amount
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>
                          {get(
                            businessActivity,
                            'attributes.capital_amount_human'
                          ) || '-'}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="180">
                        Gross Amount
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>
                          {get(
                            businessActivity,
                            'attributes.gross_amount_human'
                          ) || '-'}
                        </b>
                      </td>
                    </tr>
                    {Object.entries(details).map(item => {
                      return (
                        <tr key={`bpls_business_detail${item[0]}`}>
                          <td className="text-dark" width="180">
                            {ucwords(item[0].replace(/_/g, ' '))}
                          </td>
                          <td className="text-dark" width="1">
                            :
                          </td>
                          <td colSpan={4}>
                            <b>{item[1] || '-'}</b>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            );
          })}
        </div>
        <div className="equal-box-col mt-2">
          {(items.item || []).map((finalData, index) => {
            const details = get(finalData, 'details') || {};
            return (
              <div
                className={`col-12 p-3 rounded ${
                  index > 0 ? 'border-top' : ''
                }`}
                key={finalData.id}
              >
                <span className="text-primary font-weight-bold"> Changed Information </span>
                <span className="d-flex align-items-end justify-content-end">
                  <button
                    onClick={handleUpdateBusinessActivity(finalData, index)}
                    type="button"
                    className="btn-blank btn-sm"
                    disabled={viewUpdateForm === true}
                  >
                    <i className="far fa-edit icon-edit" />
                  </button>
                </span>
                <table className="transaction-table table table-borderless table-sm mt-2">
                  <tbody>
                    <tr>
                      <td className="text-dark" width="180">
                        Business Nature
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>{get(finalData, 'business_nature_name') || '-'}</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="180">
                        Business Line
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>{get(finalData, 'business_line_name') || '-'}</b>
                      </td>
                    </tr>
                    {Object.entries(details).map(item => {
                      return (
                        <tr key={`bpls_business_detail${item[0]}`}>
                          <td className="text-dark" width="180">
                            {ucwords(item[0].replace(/_/g, ' '))}
                          </td>
                          <td className="text-dark" width="1">
                            :
                          </td>
                          <td colSpan={4}>
                            <b>{item[1] || '-'}</b>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                {/* <div className="col-12 form-group">
                  Business Nature :{' '}
                  <b>{get(finalData, 'business_nature_name') || '-'}</b>
                </div>
                <div className="col-12 form-group">
                  Business Line :{' '}
                  <b>{get(finalData, 'business_line_name') || '-'}</b>
                </div>

                {Object.entries(details).map(item => {
                  return (
                    <div
                      className="col-12 form-group"
                      key={`bpls_business_detail${item[0]}`}
                    >
                      <span className="text-dark">
                        {ucwords(item[0].replace(/_/g, ' '))} :{' '}
                        <b>{item[1] || '-'}</b>
                      </span>
                    </div>
                  );
                })} */}
                {viewUpdateForm === true && indexSelected === index && (
                  <>
                    <UpdateBusinessActivity
                      previousActivity={previousActivity}
                      businessActivityInfo={formData}
                      handleOnUpdate={handleOnUpdate}
                      closeModal={closeUpdateModal}
                      viewUpdateForm={viewUpdateForm}
                    />
                  </>
                )}
              </div>
            );
          })}
          {/* {viewUpdateForm === true && (
            <>
              <UpdateBusinessActivity
                previousActivity={previousActivity}
                businessActivityInfo={formData}
                handleOnUpdate={handleOnUpdate}
                closeModal={closeUpdateModal}
                viewUpdateForm={viewUpdateForm}
              />
            </>
          )} */}
        </div>
      </div>
    </div>
  );
}

ExistingBusinessActivityList.propTypes = {
  value: PropTypes.instanceOf(Array).isRequired,
  onChange: PropTypes.instanceOf(Function).isRequired,
  previousActivity: PropTypes.instanceOf(Object).isRequired,
  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
  necessaryFieldsList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),]);

export default enhance(ExistingBusinessActivityList);
